import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { ReviewPage } from '#/modules/ai/back-office/review-page/review-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

/**
 * `datasetId` is optional: it is what lets the screen read that case's proposed labels, when the run was opened from one.
 *
 * `evaluationRunId` and `caseId` travel together and only from an evaluation's results: they are what turn this screen
 * from "the document and its labels" into "and here is what that run got wrong on it". Absent, nothing changes.
 */
const searchSchema = type({
  workflowId: 'string',
  'datasetId?': 'string',
  'evaluationRunId?': 'string',
  'caseId?': 'string',
})

export const Route = createFileRoute('/bo/ai/review/$runId')({
  beforeLoad: (options) => requirePermissions(options, ['aiAnalysis.review.read']),
  validateSearch: searchSchema,
  component: function Component() {
    const { runId } = Route.useParams()
    const { datasetId, workflowId, evaluationRunId, caseId } = Route.useSearch()
    return (
      <ReviewPage
        key={runId}
        workflowId={workflowId}
        runId={runId}
        {...(datasetId !== undefined ? { datasetId } : {})}
        {...(evaluationRunId !== undefined ? { evaluationRunId } : {})}
        {...(caseId !== undefined ? { caseId } : {})}
      />
    )
  },
})
